import { DisplayAdComponent } from "../components/display-ad-component";

export function declareGlobals(scope: any) {
  scope.__ark_ads__ = scope.__ark_ads__ || {};
  scope.__ark_ads__.displayAd = DisplayAdComponent;
}
